import { MatDialog, MatDialogRef} from '@angular/material';
import { DReciboPagoComponente } from '../componentes/drecibo-pago.componente';
import { Injectable, ElementRef, Renderer } from '@angular/core';
import { DContextoMuisca } from '@dian/core';
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DInterfacePagoFormulario } from '@dian-cmp/formulario';

@Injectable()
export class DReciboPagoDialogoServicio implements DInterfacePagoFormulario {  
    
    /**
    * @constructor
    */
    constructor(
        private dialog: MatDialog
    ){ }  

    /**
    * @desc Funcion para mostrar el dialogo del recibo de pago 490
    * @param {DContextoMuisca} contexto
    * @param {boolean} tieneFirmaElectronica
    * @param {DLiquidacionRecibo} liquidacion
    * @param {String} fecha
    * @param {String} mensajeAntesGuardar
    * @param {boolean} pagoPSE   
    */
    public mostrarDialogoReciboPago(contexto: DContextoMuisca, tieneFirmaElectronica: boolean, liquidacion: DLiquidacionRecibo, fecha?: string, mensajeAntesGuardar?: string, pagoPSE: boolean = true): MatDialogRef<DReciboPagoComponente> {
        let dialogo = { 
            disableClose: true, 
            backdropClass: 'backdrop-recibo-pago'
        };

        let width = window.innerWidth;
        let height = window.innerHeight;
        
        if (width <= 599) {
            dialogo['minWidth'] = width + 'px'; 
            ///dialogo['maxHeight'] = '75vh';
        }  

        let dialogRef = this.dialog.open(DReciboPagoComponente, dialogo);
        dialogRef.componentInstance.contextoUsuario = contexto;
        dialogRef.componentInstance.modelo = liquidacion;
        dialogRef.componentInstance.tieneFirmaElectronica = tieneFirmaElectronica;
        //dialogRef.componentInstance.disableCreditoLinea = disableCreditoLinea; 
        dialogRef.componentInstance.usaPagoPSE = pagoPSE; 
        if (mensajeAntesGuardar) dialogRef.componentInstance.mensajeAntesGuardar = mensajeAntesGuardar;
        return dialogRef;
    }    
}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/servicios/drecibo-pago-dialogo-servicio.ts